import appLocaleData from "react-intl/locale-data/en";
import appLocaleDataTr from "react-intl/locale-data/tr";
import appLocaleDataAr from "react-intl/locale-data/ar";
import appLocaleDataEs from "react-intl/locale-data/es";

import enMessages from "../locales/en_US";
import trMessages from "../locales/tr_TR";
import arMessages from "../locales/ar_AR";
import esMessages from "../locales/es_ES";

const Dictionary = (lng, dictionary) => {
  let locale = "en-US";
  let data = appLocaleData;
  let messages = { ...enMessages() };

  if (lng === "ar") {
    locale = "ar-AR";
    data = appLocaleDataAr;
    messages = { ...arMessages() };
  }
  if (lng === "tr") {
    data = appLocaleDataTr;
    locale = "tr-TR";
    messages = { ...trMessages() };
  }
  if (lng === "es") {
    data = appLocaleDataEs;
    locale = "es-ES";
    messages = { ...esMessages() };
  }
  return { messages, locale, data };
};
export default Dictionary;
